import { createAction, props } from '@ngrx/store';
import { RecoveryFlow } from '@ory/client';

export const ClearRecoveryFlow = createAction('[Auth] Clear recovery flow');

export const RequestBeginAccountRecovery = createAction(
  '[Auth][Request] Begin account recovery',
  props<{ email: string }>()
);
export const SuccessBeginAccountRecovery = createAction(
  '[Auth][Response][Success] Begin account recovery',
  props<{ flow: RecoveryFlow }>()
);
export const FailBeginAccountRecovery = createAction(
  '[Auth][Response][Fail] Begin account recovery',
  props<{ error: any }>()
);

export const RequestCompleteAccountRecovery = createAction(
  '[Auth][Request] Complete account recovery',
  props<{ code: string }>()
);

export const SuccessCompleteAccountRecovery = createAction(
  '[Auth][Response][Success] Complete account recovery',
  props<{ res: any; passwordChangeFlowId: string }>()
);

export const FailCompleteAccountRecovery = createAction(
  '[Auth][Response][Fail] Complete account recovery',
  props<{ error: any }>()
);
